import React from 'react';
import PropTypes from 'prop-types';

import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import Loader from '@Components/Loader';
import { spinnerTypes } from './GlobalSpinnerConstants';

import './GlobalSpinner.scss';

const spinnerId = 'global-spinner-id';

export default function GlobalSpinner(props) {
  const { isShown, spinnerType } = props;

  if (!isShown) {
    return null;
  }

  if (spinnerType === spinnerTypes.progress) {
    return (
      <div className="global-spinner">
        <Loader className="global-spinner--target" percentages={0} />
      </div>
    );
  }

  return <RxSpinnerComponent autoStart position="fixed" spinnerId={spinnerId} />;
}

GlobalSpinner.propTypes = {
  isShown: PropTypes.bool.isRequired,
  spinnerType: PropTypes.string,
};
